import { ROUTES } from '@/constants/routes';
import { matchProfileRoute } from '@/components/CustomLink/CustomLink.helpers';
import { QUERY } from '@/constants/common';

export function getAddBalanceHref(asPath: string) {
  if (!matchProfileRoute(asPath)) {
    return ROUTES.addBalance;
  }

  const [url] = asPath.split('#');
  return `${url}#${QUERY.replenishment}`;
}

export const getProfileMenuItems = (
  handleLogout: (event: React.MouseEvent) => void,
  asPath: string,
  handleAddBalanceClick: (event: React.MouseEvent) => void | Promise<void>
): {
  href: string;
  translationKey: string;
  dataStat?: string;
  onClick?: (event: React.MouseEvent) => void | Promise<void>;
}[] => {
  return [
    { href: ROUTES.profile, translationKey: 'pages.cabinet.my_ads' },
    {
      href: getAddBalanceHref(asPath),
      translationKey: 'pages.cabinet.add_private_account',
      dataStat: 'desktop-header-add-balance',
      onClick: handleAddBalanceClick,
    },
    { href: ROUTES.bookmarks, translationKey: 'pages.bookmarks.favorites' },
    {
      href: ROUTES.session,
      translationKey: 'common.exit',
      onClick: handleLogout,
    },
  ];
};
